// Constantes compartidas para @react-google-maps/api.
// CRÍTICO: el Loader de esta librería es un singleton global — si dos componentes
// lo inicializan con opciones distintas (ej. libraries diferentes), lanza error.
// Todos los componentes que usen useJsApiLoader deben importar desde aquí.
export const GOOGLE_MAPS_LIBRARIES = ['places'];
